'use client';
import { Conditional } from '@cat-ecom/pcc-components';
import { PurifiedHtml } from 'components/purified-html';

export const ECTContent = ({
  text,
  url,
  className,
  skipSanitize
}: {
  text: string;
  url?:string;
  className?: string;
  skipSanitize?: boolean;
}) => {
  const  html  = text;

  if (skipSanitize) {
    return (<div className={className} dangerouslySetInnerHTML={{ __html: html }} />);
  }

  return (
    <>
      <Conditional test={!!url}>
        <PurifiedHtml
          htmlString={html}
          className={className}
          forceBody
          as={'a'}
          target={'_blank'}
          href={url}
        />
      </Conditional>
      <Conditional test={!url}>
        <PurifiedHtml 
          htmlString={html} 
          className={className} 
          forceBody />
      </Conditional>
    </>
  );
};
